import * as ko from 'knockout'
import { DogFinisherViewModel, Params } from './DogFinisherViewModel'
import template from './dog.finisher.tpl.html'

if (!ko.components.isRegistered('dog-finisher')) {
  ko.components.register('dog-finisher', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new DogFinisherViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
